/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CaptchaText/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CaptchaText({
  children,
  viewPath = "/DesignSystem/CaptchaInfo/CaptchaText",
  text = ""
  
}) {
  return (<React.Fragment
>
<span
  data-testid="CaptchaText.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}